import React from "react";
import {CatalogRelatedArticle} from "../../../../models/articles/catalog/search";
import {Image, Tag} from "antd";
import placeholder from "../../../catalog/images/placeholder.png";
import "./article-card.scss"
import {Link} from "react-router-dom";
import {useRequiredLayers} from "../../../../utils/context";
import {RootStoreContext} from "../../../../stores/root/root";
import {RootControllersContext} from "../../../../controllers/root/root.controllers";

interface ArticleRelatedProps {
    article: CatalogRelatedArticle;
    imageSize: number;
}

function createUrl(sku: string, imageSize: number) {
    return "/product_photos/" + imageSize + "/photos/" + sku + ".jpg";
}

const tagTypesMap: Record<string, string> = {
    'aggregator' : 'Partial replacement',
    'left-right' : 'Opposite',
    'lower-upper': 'Opposite',
    'upper-lower': 'Opposite',
    'front-rear' : 'Opposite',
    'pcs'        : 'Another quantity',
    'compatible' : 'Compatible',
    'kit'        : 'KIT',
    'replacement': 'Replacement',
}

export const ArticleCard: React.FC<ArticleRelatedProps> = ({article, imageSize}) => {

    const {controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)

    return (
        <div className={"article-related-article-card"}>
            <div className={"article-related-article-card-image"}>
                {tagTypesMap[article.mappedType] ? (
                    <Tag className={"article-related-article-card-type"} color={"#f93822"}>
                        {tagTypesMap[article.mappedType]}
                    </Tag>
                ) : null}
                <Image
                    alt={article.name}
                    width={100}
                    height={100}
                    src={loginController.generateUri(createUrl(article.name, imageSize))}
                    fallback={placeholder}
                    preview={false}
                />
            </div>
            <div className={"article-related-article-card-title"}>
                <Link to={"/catalog/article/" + article.name}>{article.name}</Link>
            </div>
            <div className={"article-related-article-card-desc"}>
                {article.description}
            </div>
        </div>
    );
};
